import React from "react";
import { Box, Typography } from "@mui/material";

export default function ServicesCard({ img, imgAlt, title }) {
  return (
    <Box
      sx={{
        width: "350px", // fixed card width
        //height: "275px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        //justifyContent: "space-between", // evenly space image and text

        borderRadius: "12px",
        boxSizing: "border-box",
        //marginBottom: "20px",
        //marginBottom: "20px",
        //border: "1px solid blue",
      }}
    >
      <img
        src={img}
        alt={imgAlt}
        style={{
          width: "100%",
          height: "220px",
          objectFit: "cover",
          borderRadius: "10px",
          border: "1px solid #F04336",
        }}
      />

      <Typography
        sx={{
          color: "#F04336",
          fontSize: "20px",
          textAlign: "center",
          wordWrap: "break-word",
          fontFamily: "Nunito",
          fontWeight: 800,
          marginTop: "10px",
        }}
      >
        {title}
      </Typography>
    </Box>
  );
}
